const DEFAULT_ORDER_PART_FORM = {
  name: "",
  tickets: [],
  link: "",
  vendor_part_number: "",
  description: "",
  vendor: "",
  status: "Ordered",
  ordered_date: "",
  po_number: "",
  quantity: "1",
  each_price: "0.00",
  shipping_price: "0.00",
  total_price: "0.00",
  payment_method: "Credit Card",
  eta: "",
  tracking: "",
  notes: "",
};

export default DEFAULT_ORDER_PART_FORM;
